<!-- FAQ Section -->
<section
  class="py-12 sm:py-20 lg:py-24 border-t transition-colors"
  [ngClass]="theme === 'warm' ? 'bg-[#fbf9f5] border-stone-200 text-stone-900' : (theme === 'bold' ? 'bg-slate-950 text-white border-blue-950' : 'bg-base-200/50 border-base-300 text-base-content')"
  aria-labelledby="faq-heading"
>
  <div class="container mx-auto px-4 sm:px-6">
    <!-- Section Header -->
    <div class="text-center max-w-3xl mx-auto mb-10 sm:mb-16 space-y-3 sm:space-y-4">
      <div
        class="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider"
        [ngClass]="theme === 'warm' ? 'bg-amber-500/15 text-amber-900 border border-amber-400/40' : (theme === 'bold' ? 'bg-red-600/20 text-red-300 border border-red-500/40' : 'bg-primary/10 text-primary border border-primary/20')"
      >
        <i class="fa-solid fa-circle-question"></i>
        <span>Got Questions?</span>
      </div>
      <h2
        id="faq-heading"
        class="text-2xl sm:text-4xl font-extrabold tracking-tight break-words px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
      >
        Frequently Asked Questions
      </h2>
      <p
        class="text-sm sm:text-lg leading-relaxed px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/70')"
      >
        Find answers to common questions about joining live classes, courses, and platform features.
      </p>
    </div>

    <!-- Accordion List using DaisyUI Collapse -->
    @if (activeFaqs.length > 0) {
      <div class="max-w-3xl mx-auto space-y-3 sm:space-y-4 mb-10 sm:mb-16">
        @for (faq of activeFaqs; track $index) {
          <div
            class="daisy-collapse daisy-collapse-arrow daisy-card border shadow-sm rounded-xl sm:rounded-2xl transition-all"
            [ngClass]="theme === 'warm' ? 'bg-[#fffdfa] border-stone-200 text-stone-900' : (theme === 'bold' ? 'bg-slate-900 border-slate-700 text-white' : 'bg-base-100 border-base-300 text-base-content')"
          >
            <input type="radio" name="faq-accordion" [checked]="$first" />
            <div
              class="daisy-collapse-title text-base sm:text-lg font-bold flex items-center gap-2.5 sm:gap-3 py-3.5 sm:py-5 px-4 sm:px-6"
              [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
            >
              <i
                class="fa-solid fa-circle-question text-lg sm:text-xl shrink-0"
                [ngClass]="theme === 'warm' ? 'text-amber-600' : (theme === 'bold' ? 'text-blue-400' : 'text-primary')"
              ></i>
              <span>{{ faq.question }}</span>
            </div>
            <div
              class="daisy-collapse-content text-xs sm:text-sm leading-relaxed px-4 sm:px-6 pb-4 sm:pb-6 pt-0"
              [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/80')"
            >
              <p
                class="p-3 sm:p-4 rounded-xl border whitespace-pre-line"
                [ngClass]="theme === 'warm' ? 'bg-stone-50 border-stone-200/80 text-stone-700' : (theme === 'bold' ? 'bg-slate-800/80 border-slate-700 text-slate-200' : 'bg-base-200/60 border-base-300 text-base-content/80')"
              >
                {{ faq.answer }}
              </p>
            </div>
          </div>
        }
      </div>
    }

    <!-- Contact Support Box -->
    @if (contactEmail) {
      <div
        class="daisy-card border p-6 sm:p-8 rounded-2xl sm:rounded-3xl text-center max-w-2xl mx-auto shadow-sm space-y-3 sm:space-y-4"
        [ngClass]="theme === 'warm' ? 'bg-[#fffdfa] border-stone-200 text-stone-900' : (theme === 'bold' ? 'bg-slate-900 border-slate-700 text-white' : 'bg-base-100 border-base-300 text-base-content')"
      >
        <div
          class="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto text-lg sm:text-xl"
          [ngClass]="theme === 'warm' ? 'bg-amber-500/15 text-amber-700' : (theme === 'bold' ? 'bg-blue-500/20 text-blue-400' : 'bg-primary/10 text-primary')"
        >
          <i class="fa-solid fa-headset"></i>
        </div>
        <h3
          class="text-lg sm:text-xl font-bold"
          [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
        >
          Still Have Questions?
        </h3>
        <p
          class="text-xs sm:text-sm"
          [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/70')"
        >
          Our support team is here to assist you with class schedules, payments, and account setup.
        </p>
        <div class="pt-2 flex justify-center">
          <a
            [href]="'mailto:' + contactEmail"
            class="daisy-btn daisy-btn-outline rounded-xl gap-2 text-xs sm:text-sm"
            [ngClass]="theme === 'warm' ? 'border-amber-600 text-amber-800 hover:bg-amber-600 hover:text-white' : (theme === 'bold' ? 'border-blue-500 text-blue-300 hover:bg-blue-600 hover:text-white' : 'daisy-btn-primary')"
          >
            <i class="fa-solid fa-envelope"></i>
            <span>Contact Support</span>
          </a>
        </div>
      </div>
    }

  </div>
</section>
